export enum TemplateAssetType {
	DASHBOARD = 'DASHBOARD',
	METRIC = 'METRIC',
	FILTER = 'FILTER',
}
